import PropTypes from 'prop-types';

import UpgradePlan from 'features/account/my-plan/UpgradePlan';
import Modal from 'honeydew/Modal';
import { closeModal } from 'utils/globalUtils';

function UpgradeModal({ account, plan, setSuccess, setUpgradeModal, subscription, upgradeModal }) {
    const closeUpgradeModal = () => {
        closeModal(setUpgradeModal);
    };

    return (
        <Modal open={upgradeModal} onClose={closeUpgradeModal}>
            <UpgradePlan
                account={account}
                closeUpgradeModal={closeUpgradeModal}
                plan={plan}
                subscription={subscription}
                setSuccess={setSuccess}
                modalStyles
                buttonCopy="Confirm Upgrade"
            />
        </Modal>
    );
}

UpgradeModal.propTypes = {
    account: PropTypes.shape({}),
    plan: PropTypes.shape({}),
    setSuccess: PropTypes.func.isRequired,
    setUpgradeModal: PropTypes.func.isRequired,
    subscription: PropTypes.shape({}),
    upgradeModal: PropTypes.bool.isRequired,
};

UpgradeModal.defaultProps = {
    account: {},
    plan: {},
    subscription: {},
};

export default UpgradeModal;
